<template>
  <component :is="component" :chat />
</template>

<script setup>
import { computed } from "vue";

// Define props for the chat component
const props = defineProps({
  chat: {
    type: Object,
    required: true,
    default: () => ({}),
  },
});

const component = computed(() => {
  const { systemMessage = false } = props.chat || {};

  return systemMessage ? "CChatSystemMessage" : "CChatUserMessage";
});
</script>
